import { fetchJson } from './fetchJson'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function get<T>(url: string, cancelToken?: any): Promise<T> {
  return fetchJson({ method: 'GET', url, cancelToken })
}
